import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  ActionsEnum,
  FetchScreen,
  HideFeedbackCardForFeature,
  IHideFeedbackCard,
  SetScreen,
} from './feedback-data.actions';
import {
  FeedbackScreenEnum,
  IFeedbackCardDismissed,
  IScreenData,
} from './feedback-data.data';

// feature name
export const FEATURE_NAME = 'feedback-data';

// state interface
export interface IState {
  feedbackCardsDismissed: IFeedbackCardDismissed;
  screens: IScreenData;
}

// initial state
export const initialState: IState = {
  feedbackCardsDismissed: {},
  screens: {},
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.HIDE_FEEDBACK_CARD_FOR_FEATURE]: function (
      state: IState,
      { payload }: HideFeedbackCardForFeature
    ): IState {
      const { accountId, featureName }: IHideFeedbackCard = payload;
      const feedbackCardsDismissed = state.feedbackCardsDismissed;
      const feedbackCardDismissedForAccount =
        feedbackCardsDismissed[accountId] || {};

      return {
        ...state,
        feedbackCardsDismissed: {
          ...feedbackCardsDismissed,
          [accountId]: {
            ...feedbackCardDismissedForAccount,
            [featureName]: true,
          },
        },
      };
    },
    [ActionsEnum.FETCH_SCREEN]: function (
      state: IState,
      { payload }: FetchScreen
    ): IState {
      const { screenId } = payload;

      return {
        ...state,
        screens: {
          ...state.screens,
          [screenId]: null,
        },
      };
    },
    [ActionsEnum.SET_SCREEN]: function (
      state: IState,
      { payload }: SetScreen
    ): IState {
      return {
        ...state,
        screens: {
          ...state.screens,
          ...payload,
        },
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getFeedbackHiddenForFeatureNameForAccount = (
  featureName: string,
  accountId: string
) =>
  createSelector(selectFeature, (state: IState): boolean => {
    const feedbackCardDismissedForAccount =
      state.feedbackCardsDismissed[accountId] || {};

    return !!feedbackCardDismissedForAccount[featureName];
  });

export const getScreenById = (screenId: FeedbackScreenEnum) =>
  createSelector(selectFeature, (state: IState): any => {
    return state.screens[screenId];
  });
